import { call, put, takeLatest, delay } from 'redux-saga/effects';
import { SEG_CMP } from 'src/store/ActionTypes';

import * as api from 'src/store/api';

function* fetchSegments(action) {
  try {
    const {
      payload: { segmentIds = [], clusterIds = [] },
    } = action;
    const segments = [];
    const clusters = [];
    for (let i = 0; i < segmentIds.length; i += 1) {
      const segment = yield call(api.fetchSegment, segmentIds[i]);
      segments.push(segment);
    }
    for (let i = 0; i < clusterIds.length; i += 1) {
      const cluster = yield call(api.fetchCluster, clusterIds[i]);
      clusters.push(cluster);
    }
    yield put({
      type: SEG_CMP.FETCH_SEGMENTS_SUCCEEDED,
      payload: { segments, clusters },
    });
  } catch (e) {
    yield put({
      type: SEG_CMP.FETCH_SEGMENTS_FAILED,
    });
  }
}

function* editSegment(action) {
  try {
    const {
      payload: { id, payload },
    } = action;
    yield call(api.updateSegment, id, payload);
    yield put({
      type: SEG_CMP.EDIT_SEGMENT_SUCCEEDED,
      payload: {
        id,
        payload,
      },
    });
  } catch (e) {
    yield put({
      type: SEG_CMP.EDIT_SEGMENT_FAILED,
    });
  } finally {
    yield delay(500);
    yield put({
      type: SEG_CMP.UNSET,
      payload: 'editSegmentStatus',
    });
  }
}

function* fetchSegmentsSaga() {
  yield takeLatest(SEG_CMP.FETCH_SEGMENTS, fetchSegments);
}

function* editSegmentSaga() {
  yield takeLatest(SEG_CMP.EDIT_SEGMENT, editSegment);
}

export default [fetchSegmentsSaga(), editSegmentSaga()];
